import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import apiClient from "../apiClient"; // API 클라이언트

const Login = ({ setIsAuthenticated }) => {
  const [userid, setUserid] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const incrementFailCount = async () => {
    try {
      await apiClient.post("/api/Auth/login-fail", { userid });
    } catch (err) {
      console.error("Fail count update failed:", err);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!userid) {
      setErrorMessage("아이디를 입력해주세요.");
      return;
    }
    if (!password) {
      setErrorMessage("비밀번호를 입력해주세요.");
      return;
    }

    try {
      const response = await apiClient.post("/api/Auth/login", {
        userid,
        password,
      });

      if (response.data.message === "user login success") {
        localStorage.setItem("userid", response.data.user.UserId);
        localStorage.setItem("username", response.data.user.AdminName);
        localStorage.setItem("usertype", response.data.user.UserType);
        localStorage.setItem("workplaceid", response.data.user.WorkplaceId);

        setIsAuthenticated(true);
        navigate("/entryexit");
      } else {
        if (response.data.message === "비밀번호가 일치하지 않습니다.") {
          setErrorMessage(
            "비밀번호가 일치하지 않습니다. (5회 이상 실패시 계정 비활성화 처리됩니다.)",
          );
          await incrementFailCount();
        } else if (response.data.message === "5회 이상 로그인 실패") {
          setErrorMessage("계정 비활성화 처리 (5회 이상 실패)");
        } else {
          setErrorMessage(response.data.message);
        }
      }
    } catch (error) {
      console.error("Login failed:", error);
      setErrorMessage("서버 통신 오류입니다. 다시 시도해주세요.");
    }
  };

  return (
    <div className="login_wrapper">
      <div className="loginbox">
        <h1 className="login_title">MIZE Smart Safety</h1>
        <div className="login_desc">관리자 로그인</div>

        {errorMessage && <div className="login_errormsg">{errorMessage}</div>}

        <form onSubmit={handleLogin} name="login">
          <div className="login_inputbox">
            <input
              type="text"
              placeholder="아이디를 입력하세요"
              value={userid}
              onChange={(e) => setUserid(e.target.value)}
              className="login_input"
            />
            <input
              type="password"
              placeholder="비밀번호를 입력하세요"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login_input"
            />
            <button type="submit" className="login_button">
              로그인
            </button>
          </div>

          <div className="login_links">
            <div className="login_links_row">
              <a
                href="/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                개인정보처리방침
              </a>
              <span className="link_divider">|</span>
              <a
                href="/personal-info-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                개인위치정보 처리방침
              </a>
            </div>

            <div className="login_links_row">
              <a
                href="/service-terms"
                target="_blank"
                rel="noopener noreferrer"
              >
                서비스 이용약관
              </a>
              <span className="link_divider">|</span>
              <a
                href="/location-terms"
                target="_blank"
                rel="noopener noreferrer"
              >
                위치정보 이용약관
              </a>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
